var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.creditScore ? _vm.creditScore.credit_score_status : 'New Borrower'}},[_vm._v("\n  "+_vm._s(_vm.creditScore ? Math.round(_vm.creditScore.showing_score * 100) / 100 : "NB")+"\n  "),(
      _vm.creditScore && _vm.creditScore.credit_score < _vm.creditScore.previous_score
    )?_c('v-icon',{attrs:{"small":"","color":"error"}},[_vm._v("\n    arrow_downward\n  ")]):(
      _vm.creditScore && _vm.creditScore.credit_score > _vm.creditScore.previous_score
    )?_c('v-icon',{attrs:{"small":"","color":"success"}},[_vm._v("\n    arrow_upward\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }